/*=========================================================================================
  File Name: moduleDashBoardState.js
  Description: Email DashBoard State
  ----------------------------------------------------------------------------------------

==========================================================================================*/


export default {
    dataDashBoard : [],
    listTypeDashBoard : [],
    listUserDashBoard : [],
    listOptionsDashBoard : '[]',
  }
  